import { getEntityRangeIds } from 'lib/misc';
import { SelectListOption } from './types';

/**
 * Get list of entity identifiers matching the specified range boundaries
 *
 * @param {Array} options Source list of entities
 * @param {number} startIndex Range start index
 * @param {number} endIndex Range end index
 */
export const getSelectionRangeIds = <TValue extends string | number>(
  options: Array<SelectListOption<TValue>>,
  startIndex: number,
  endIndex: number,
) => getEntityRangeIds(options, startIndex, endIndex, option => option.value);
